import { IMessageItem, MessageType } from '../../../model/api-modules';
import { ModalWrap } from '../modal-wrap';
import { getCustomSystemTitle, getCustomUserSubject } from './config';
import './style.scss';
import { getContentByMessage } from './lib';
import getFormatMessage from '../../../locales/get-format-message';
interface IProps {
  readonly onCloseFail: () => void;
  readonly onOk: () => Promise<boolean>;
  readonly message: IMessageItem;
  readonly isClosed?: boolean;
}

export const MessageModal = (props: IProps) => {
  const record = props.message;
  // console.log('props.isClosed1111111111',props.isClosed);
  return (
    <ModalWrap
      width="720px"
      onOk={props.onOk}
      onClose={props.onCloseFail}
      oKText={getFormatMessage('i_know')}
      maskClosable={props.isClosed ? props.isClosed : true}
      // title={`[${getMsgSubject(record.Type, record.SubType)}] ${
      //   record.Type === MessageType.UserActive
      //     ? getCustomUserSubject(record.SubType)
      //     : record.Title
      // }`}
      title={
        record.Type === MessageType.UserActive
          ? getCustomUserSubject(record.SubType)
          : `${getCustomSystemTitle(record.SubType)}${record.Title}`
      }
      className="message-modal"
    >
      <div className="content">
        {/* <MarkdownPreview value={record.Content}></MarkdownPreview> */}
        {getContentByMessage(props.message, {
          fontSize: 'var(--font-size-md)',
          color: 'var(--color-text-tertiary)',
        })}
      </div>
    </ModalWrap>
  );
};
